import { Box } from '@hopskipdrive/react-components';
import { colorPalette } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const StyledToggle = styled(Box)`
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .MuiToggleButtonGroup-root {
    background-color: ${colorPalette.navy95};
  }
`;
